import type {
  PaginatedEmailLog,
  QueryEmailLogsArgs,
} from '@tribeplatform/gql-client/types'

import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '../../lib/react-query/useInfiniteQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getEmailLogsKey } from '../../utils/keys/email.keys.js'

export const useEmailLogs = (options: {
  variables: QueryEmailLogsArgs
  useInfiniteQueryOptions?: UseInfiniteQueryOptions<PaginatedEmailLog>
}) => {
  const { variables, useInfiniteQueryOptions } = options || {}
  const { client } = useTribeClient()
  const emailLogsKey = getEmailLogsKey({ variables })

  return useInfiniteQuery<PaginatedEmailLog>(
    emailLogsKey,
    ({ pageParam: after }) => client?.emailLogs({ after, ...variables }),
    useInfiniteQueryOptions,
  )
}
